import React, { useEffect, useState } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Home from '../../views/sandbox/home/Home'
import UserList from '../../views/sandbox/user-manage/UserList'
import GroupList from '../../views/sandbox/right-manage/GroupList'
import AvailableBookingItemList from '../../views/sandbox/available-booking-item-manage/List'
import NoPermission from '../../views/nopermission/NoPermission'
import axios from 'axios'
import { Spin } from 'antd'
import { connect } from 'react-redux'
import MyHistory from '../../views/sandbox/booking/MyHistory/MyHistory'
import AllBooking from '../../views/sandbox/booking/AllBooking/AllBooking'
import Profile from '../../views/sandbox/profile/Profile'



const localRouteMap = {//用來對應後端傳來的路由key映射到react組建
    '/booking/my-history': MyHistory,
    '/booking/all': AllBooking,
    '/user-manage/list': UserList,
    '/right-manage/group/list': GroupList,
    '/available-booking-item-manage/list': AvailableBookingItemList,
    '/profile': Profile,
}

function NewsRouter(props) {
  const [backRouteList, setbackRouteList] = useState([])
  useEffect(()=>{
    axios.get('/api/page-route?flat=true').then(res=>{
      setbackRouteList(res.data)
    }).catch(err=>{
      console.error('錯誤',err)
    })
  },[])

  const checkRoute = (backendRouteItem) => {
    return (
      backendRouteItem.key in localRouteMap //確認前後端路由匹配
      &&
      backendRouteItem.route_permission === 1
    )
  }

  const checkUserPermission = (backendRouteItem) => {
    return props.groupPermission.permissions.includes(backendRouteItem.key)
  }

  return (
    <Switch>
      {
        Object.values(backRouteList).map((item)=>{
          if(checkRoute(item) && checkUserPermission(item)){
            //當路由是View or update時，通常為/view or update/id
            if(item.key.split('/').pop() === 'view' ||
              item.key.split('/').pop() === 'update'
            ){
              return <Route path={`${item.key}/:id`} key={item.key} component={localRouteMap[item.key]} exact/>
            }
            return <Route path={item.key} key={item.key} component={localRouteMap[item.key]} exact />
          }
          return  null
        })
      }
      <Redirect from="/" to="booking/all" exact/>
      <Route path="*" component={NoPermission} />
    </Switch>
  )
}

const mapStateToProps = ({
  loadingReducer:{isLoading},
  userProfileReducer: {groupPermission}
}) => {
  return {
    isLoading,
    groupPermission

  }
}

export default connect(mapStateToProps)(NewsRouter)
